import { render } from "./UpdateForm.vue?vue&type=template&id=9e1d6594&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"

import "./UpdateForm.vue?vue&type=style&index=0&id=9e1d6594&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e1d6594"]])

export default __exports__